// src/components/IconButton.tsx
import React from "react";

interface CustomButtonProps {
  label: string;
  onClick?: () => void;
  padding?: {
    left?: number;
    top?: number;
    bottom?: number;
    right?: number;
  };
  active?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  label,
  onClick,
  padding,
  active = false,
}) => {
  const { left = 7, top = 4, bottom = 3, right } = padding || {};

  return (
    <button
      onClick={onClick}
      style={{
        paddingLeft: `${left * 0.25}rem`,
        paddingTop: `${top * 0.25}rem`,
        paddingBottom: `${bottom * 0.25}rem`,
        paddingRight: `${(right ?? 4) * 0.25}rem`,
      }}
      className={`flex w-full items-center rounded-xl text-left text-sm font-medium transition ${
        active
          ? "bg-primary/10 text-primary"
          : "text-slate-500 hover:bg-white hover:text-slate-900"
      }`}
    >
      <span className="pl-1">{label}</span>
    </button>
  );
};

export default CustomButton;
